import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Hero from "../../sections/home/Hero";
import Propos from "../../sections/home/Propos";
import Promo from "../../sections/home/Promo";
import Contact from "../../sections/home/Contact";
import Garantie from "../../sections/home/Garantie";

function Home() {
  return (
    <>
      <Helmet>
        <title>Acceuil</title>
      </Helmet>
      <Hero />
      <Propos />
      <Promo />
      <Garantie />
      <Contact />
    </>
  );
}

export default Home;
